<script setup>
import { ref } from 'vue';
import { ORDER_IMPORT_TYPE } from '../../../data/constants/orderImportConstants';

const importType = ref(ORDER_IMPORT_TYPE.POLES);

const options = [
  { id: ORDER_IMPORT_TYPE.POLES, title: 'Słupy' },
  { id: ORDER_IMPORT_TYPE.CABINETS, title: 'Szafy' }
];

defineExpose({ importType });
</script>

<template>
  <div>
    <h4>Wybierz typ importu</h4>
    <div class="options-list">
      <label
        v-for="option in options"
        :key="option.id"
        class="option-card"
        :class="{ selected: importType === option.id }"
      >
        <input type="radio" name="importType" :value="option.id" v-model="importType" />
        <span class="option-title">{{ option.title }}</span>
      </label>
    </div>
  </div>
</template>

<style scoped>
.options-list {
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-top: 8px;
}

.option-card {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 2px;
  padding: 10px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background-color 0.15s;
  background-color: #fff;
  width: fit-content;
  min-width: 160px;
  font-weight: normal;
}

.option-card:hover {
  border-color: #aab;
  background-color: #f8f9fa;
}

.option-card.selected {
  border-color: #1a73e8;
  background-color: #e8f0fe;
}

.option-card input[type='radio'] {
  accent-color: #1a73e8;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.option-title {
  font-size: 15px;
}
</style>
